import { CSSProperties, ReactNode } from 'react';
import { getColor } from '../../assets/theme';
import { Box, Typography } from '@mui/material';

/**
 * GroupTitle component
 *
 * This component renders a styled title box with an optional action element.
 * It's designed to be used as a header for grouped content in forms or other UI sections.
 *
 * @component
 * @param {Object} props - The component props
 * @param {string} props.title - The title text to be displayed
 * @param {CSSProperties} [props.wrapperStyle={}] - Optional custom styles for the wrapper Box
 * @param {ReactNode} [props.action] - Optional action element to be displayed on the right side of the title
 * @returns {JSX.Element} The rendered GroupTitle component
 */
const GroupTitle = ({
  title,
  wrapperStyle = {},
  action,
}: {
  title: string;
  wrapperStyle?: CSSProperties;
  action?: ReactNode;
}) => {
  const { bgColor } = getColor();

  return (
    <Box
      sx={[
        {
          bgcolor: bgColor,
          p: '8px 16px',
          borderRadius: '4px',
          mb: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        },
        wrapperStyle,
      ]}
    >
      <Typography>{title}</Typography>
      {action}
    </Box>
  );
};

export default GroupTitle;
